import styled from 'styled-components';
import React, { useContext, useEffect, useState } from 'react';
import {
  InlineVariantsLayoutAllocationInput,
  InlineVariantsLayoutAllocationText,
  InlineVariantsLayoutAllocationWrapper,
} from '@/features/editor/widgets/shared/inline-variants-layout/shared';
import { EditorContext } from '@/features/editor/context/editor-context';
import { Flexbox } from '@/components/flex';
import { formatAllocation } from '@/features/editor/widgets/targeting/shared';

export interface InlineVariantsLayoutControlGroupProps {
  device: any;
  bg?: string;
  chances?: Array<number>;

  description?: React.ReactNode;
  action?: React.ReactNode;
}

export function InlineVariantsLayoutControlGroup({
  device,
  chances,
  bg,
  description,
  action,
}: InlineVariantsLayoutControlGroupProps) {
  const controlAllocation = useControlAllocation(chances);
  return (
    <InlineVariantsLayoutAllocationWrapper device={device} bg={bg}>
      <Flexbox direction="column" justify="center" gap="0.5rem">
        <ControlText device={device}>Original</ControlText>
        {description || <ChangesSpan>No changes</ChangesSpan>}
      </Flexbox>
      <Flexbox direction="row" gap="1.5rem" align="center">
        {action}
        <ControlInput
          readOnly
          device={device}
          value={controlAllocation}
          bg={bg}
        />
      </Flexbox>
    </InlineVariantsLayoutAllocationWrapper>
  );
}

function useControlAllocation(chances: Array<number>) {
  const edCtx = useContext(EditorContext);
  const variantChances =
    chances ||
    edCtx?.experienceState?.currentExperience?.variants?.map((x) => x.chance);

  const calcControl = () => 100 - variantChances.reduce((pv, cv) => pv + cv);

  const [control, setControl] = useState(calcControl());

  useEffect(() => {
    setControl(calcControl());
  }, [variantChances?.join(``)]);

  return formatAllocation(control);
}

const ChangesSpan = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 60px;
  justify-content: center;
  padding: 0 2rem;
  color: #5b656e;

  font-family: Inter, serif;
`;

const ControlText = styled(InlineVariantsLayoutAllocationText)`
  && {
    font-weight: 600;
    padding: 0 2rem;
    color: #a6afb8;
  }
`;

const ControlInput = styled(InlineVariantsLayoutAllocationInput)`
  && {
    font-weight: 600;
    color: #b7c2c9;
    pointer-events: none;
    box-shadow: none;
    border: 1px solid ${(p) => (p.bg ? `#cdd3d9` : `transparent`)};
  }
`;
